import LazyLoadImages from "./events/ImageLoaded";

import StarterKit from "./StarterKit";

import BlockBanner from "./blocks/BlockBanner";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockImageGrid from "./blocks/BlockImageGrid";
import BlockSliderMultiple from "./blocks/BlockSliderMultiple";
import BlockSliderSimple from "./blocks/BlockSliderSimple";
import BlockMap from "./blocks/BlockMap";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockSliderImageBackgroundText from "./blocks/BlockSliderImageBackgroundText";
import BlockSliderMultipleText from "./blocks/BlockSliderMultipleText";
import BlockPriceTag from "./blocks/BlockPriceTag";
import BlockRealization from "./blocks/BlockRealization";
import BlockNews from "./blocks/BlockNews";
import Footer from "./components/Footer";
import Section from "./components/Section";
import PageSingleProgram from "./pages/PageSingleProgram";
import Stickers from "./components/Stickers";
import PageArchiveProgram from "./pages/PageArchiveProgram";
import PageHome from "./pages/PageHome";
import SubNav from "./components/SubNav";
import BlockRealizationLight from "./blocks/BlockRealizationLight";
import BlockRessourceProgram from "./blocks/BlockRessourceProgram";

// First of the first
new LazyLoadImages();

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	new StarterKit();
	new Footer();

	// Blocks
	new BlockBanner();
	// new BlockCollapse();
	// new BlockImageGrid();
	new BlockMap();
	new BlockQuotes();
	// new BlockSliderImageBackgroundText();
	// new BlockSliderSimple();
	new BlockRealizationLight();
	new BlockSliderMultiple();
	new BlockSliderMultipleText();

	new BlockNews();
	new BlockPriceTag();
	new BlockRealization();
	new BlockRessourceProgram();

	new SubNav();
	new Section();
	new Stickers();
	new PageHome();
	new PageSingleProgram();
	new PageArchiveProgram();
});

window.initMap = function () {
	window.dispatchEvent(new Event('googleMapApiLoaded'));
};
